export default class ArrayHelper {
    /**
     * Moves an element of an array in to a new position
     *
     * @param array
     * @param fromIndex
     * @param toIndex
     */
    static move(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    array, fromIndex, toIndex) {
        // Get the element
        const element = array[fromIndex];
        // Remove it from its current index
        array.splice(fromIndex, 1);
        // Add it in the new position
        array.splice(toIndex, 0, element);
    }
    /**
     * Returns whether the two arrays contain the same unique strings
     *
     * @param stringArray1
     * @param stringArray2
     * @returns
     */
    static isSameUniqueStrings(stringArray1, stringArray2) {
        const uniqueStringArray1 = [...new Set(stringArray1)].sort();
        const uniqueStringArray2 = [...new Set(stringArray2)].sort();
        return uniqueStringArray1 === uniqueStringArray2;
    }
}
//# sourceMappingURL=array-helper.js.map